import { type CSSProperties, type FC, type ReactElement } from "react";

import { css } from "@emotion/css";
import { Skeleton } from "@snapchat/snap-design-system";

import { Flexbox } from "./Flexbox.styles";

interface LoadableItemProps {
    style: CSSProperties;
    data?: Record<string, unknown>;
    children: ReactElement;
    skeletonHeight: number;
}

const loadableContainer = css`
    padding: 0 24px;
`;

export const LoadableItem: FC<LoadableItemProps> = ({ style, skeletonHeight, data, children }) => {
    if (data) {
        return children;
    }
    return (
        <Flexbox alignItems="center" style={style} className={loadableContainer}>
            <Skeleton height={skeletonHeight} />
        </Flexbox>
    );
};
